import { type UseMutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import { fetchAlarmDelete, fetchAlarmIsRead, fetchAlarmList } from '../../apis/client-side/alarm';
import type {
  AlarmDeleteParams,
  AlarmIsReadResponse,
  AlarmListParams,
  AlarmListResponse,
} from '../../apis/client-side/alarm/type';
import type { ApiBaseResponse } from '../../apis/type';
import TimeConstants from '../../utils/item';
import type { CustomUseQueryOptions } from '../type';
import { alarmQueryKeys } from './alarmQueryKeys';

export const useFetchAlarmListQuery = (
  fetchBlockListParams: AlarmListParams,
  options?: CustomUseQueryOptions<AlarmListResponse, Error>,
) =>
  useQuery({
    queryKey: alarmQueryKeys.fetchAlarmList(fetchBlockListParams).queryKey,
    queryFn: () => fetchAlarmList(fetchBlockListParams),
    staleTime: TimeConstants.ONE_MINUTE,
    ...options,
  });

// export const useFetchAlarmListIniteQuery = (
//   fetchAlarmListParams: AlarmListParams,
//   options?: UseInfiniteQueryOptions<AlarmListResponse, Error>,
// ) =>
//   useInfiniteQuery({
//     initialPageParam: null as null | { lastId: string },
//     queryKey: alarmQueryKeys.fetchAlarmList(fetchAlarmListParams).queryKey,
//     queryFn: ({ pageParam }) => {

//       const params = {
//         limit: fetchAlarmListParams.limit,
//         category: fetchAlarmListParams.category,
//         ...(pageParam?.lastId && { lastId: pageParam.lastId }),
//       };

//       return fetchAlarmList(params);
//     },
//     ...options,
//     staleTime: TimeConstants.HALF_SECOND * 10,
//     placeholderData: keepPreviousData,
//     getNextPageParam: (lastPage) => {
//       if (!lastPage?.lastId) return null;
//       return {
//         lastId: lastPage.lastId,
//       };
//     },
//     select: (data) => {
//       return {
//         ...data,
//         pages: data.pages[0],
//       };
//     },
//   });

export const useAlarmDeleteMutation = (options?: UseMutationOptions<ApiBaseResponse, Error, AlarmDeleteParams>) =>
  useMutation({
    mutationKey: alarmQueryKeys.fetchAlarmDelete().queryKey,
    mutationFn: (addBookmarkParams: AlarmDeleteParams) => fetchAlarmDelete(addBookmarkParams),
    ...options,
  });

export const useAlarmIsRead = (options?: CustomUseQueryOptions<AlarmIsReadResponse, Error>) =>
  useQuery({
    queryKey: alarmQueryKeys.fetchAlarmIsRead().queryKey,
    queryFn: () => fetchAlarmIsRead(),
    staleTime: TimeConstants.ONE_MINUTE,
    ...options,
  });
